import { spontanZahlungCheck } from "../../api/spontanrueckzahlung";
import store from "@/store";

const getDefaultState = () => {
    return { details: {} };
};

const state = getDefaultState();

const getters = {};

const actions = {
    spontanZahlungCheck({ commit, state }, amount) {
        return new Promise((resolve) => {
            if (Object.keys(state.details).length === 0) {
                commit("setLoading", true, { root: true });
            }
            spontanZahlungCheck(amount)
                .then((response) => {
                    if (response.data.Status === 200) {
                        commit("setDetails", response.data.Result);
                        resolve();
                    } else {
                        store.cache.delete(
                            "spontanrueckzahlung/spontanZahlungCheck"
                        );
                    }
                })
                .catch(() => {
                    store.cache.delete(
                        "spontanrueckzahlung/spontanZahlungCheck"
                    );
                });
        });
    },
};

const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState());
    },
    setDetails(state, details) {
        state.details = details;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
